export default {
    methods: {
        price(value) {
            var formatter = new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR"
            });

            return formatter.format(value / 100);
        }
    }
}